import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { TranslateModule } from "@ngx-translate/core";
import { NgxSpinnerModule } from "ngx-spinner";
import { NgxStripeModule } from "@nomadreservations/ngx-stripe";
import { BreadcrumbModule } from "xng-breadcrumb";
import { NgMultiSelectDropDownModule } from "ng-multiselect-dropdown";
import { SelectDropDownModule } from "ngx-select-dropdown";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatNativeDateModule } from "@angular/material/core";
import { ChartsModule } from "ng2-charts";
import { NgxPermissionsModule } from "ngx-permissions";
import { environment } from "src/environments/environment";
import { NgxMaskModule } from "ngx-mask";
import { AgmCoreModule } from "@agm/core";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { MatTableModule } from "@angular/material/table";
import { MatPaginatorModule } from "@angular/material/paginator";
import { MatSortModule } from "@angular/material/sort";
import { AccountComponent } from "./account.component";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { FunctionsService } from "src/app/services/functions.service";
import { AccountRoutingModule } from "./account-routing.module";
import { ChangePlanComponent } from "./change-plan/change-plan.component";
import { PaymentProcessedComponent } from "./payment-processed/payment-processed.component";
import { AuthInterceptorProvider } from "src/app/services/token/token-interceptor.service";


@NgModule({
    declarations: [
        AccountComponent,
        ChangePlanComponent,
        PaymentProcessedComponent
    ],
    imports: [
        AccountRoutingModule,
        BreadcrumbModule,
        CommonModule,
        FormsModule,
        MatDatepickerModule,
        MatFormFieldModule,
        MatInputModule,
        MatNativeDateModule,
        MatTableModule,
        MatPaginatorModule,
        MatProgressSpinnerModule,
        MatSortModule,
        NgbModule,
        NgxPermissionsModule,
        NgxSpinnerModule,
        NgxStripeModule.forRoot(environment.stripe_pk),
        ReactiveFormsModule,
        TranslateModule,
        MatIconModule,
        ChartsModule,
        NgxMaskModule,
        AgmCoreModule.forRoot({
            apiKey: environment.firebaseConfig.apiKey
        }),
        SelectDropDownModule,
        NgMultiSelectDropDownModule
    ],
    providers: [FunctionsService, AuthInterceptorProvider]
})
export class AccountModule {}